import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Partner\ChiftAccounting\GetPaymentSyncRunController::__invoke
* @see app/Http/Controllers/Partner/ChiftAccounting/GetPaymentSyncRunController.php
* @route '/api/chift/payment-sync/runs/{payment_sync_run}'
*/
const GetPaymentSyncRunController = (args: { payment_sync_run: string | number | { id: string | number } } | [payment_sync_run: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPaymentSyncRunController.url(args, options),
    method: 'get',
})

GetPaymentSyncRunController.definition = {
    methods: ["get","head"],
    url: '/api/chift/payment-sync/runs/{payment_sync_run}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Partner\ChiftAccounting\GetPaymentSyncRunController::__invoke
* @see app/Http/Controllers/Partner/ChiftAccounting/GetPaymentSyncRunController.php
* @route '/api/chift/payment-sync/runs/{payment_sync_run}'
*/
GetPaymentSyncRunController.url = (args: { payment_sync_run: string | number | { id: string | number } } | [payment_sync_run: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { payment_sync_run: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { payment_sync_run: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            payment_sync_run: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        payment_sync_run: typeof args.payment_sync_run === 'object'
        ? args.payment_sync_run.id
        : args.payment_sync_run,
    }

    return GetPaymentSyncRunController.definition.url
            .replace('{payment_sync_run}', parsedArgs.payment_sync_run.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Partner\ChiftAccounting\GetPaymentSyncRunController::__invoke
* @see app/Http/Controllers/Partner/ChiftAccounting/GetPaymentSyncRunController.php
* @route '/api/chift/payment-sync/runs/{payment_sync_run}'
*/
GetPaymentSyncRunController.get = (args: { payment_sync_run: string | number | { id: string | number } } | [payment_sync_run: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPaymentSyncRunController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Partner\ChiftAccounting\GetPaymentSyncRunController::__invoke
* @see app/Http/Controllers/Partner/ChiftAccounting/GetPaymentSyncRunController.php
* @route '/api/chift/payment-sync/runs/{payment_sync_run}'
*/
GetPaymentSyncRunController.head = (args: { payment_sync_run: string | number | { id: string | number } } | [payment_sync_run: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetPaymentSyncRunController.url(args, options),
    method: 'head',
})

export default GetPaymentSyncRunController